export default __webpack_public_path__ + "static/media/suitcase_selected.4e37e2d0.svg";